(() => {
	function init() {
		let options = {
			rootMargin: '0px 0px -25% 0px',
			threshold: 0
		};

		let observer = new IntersectionObserver(imageIn, options);

		let imgs = document.querySelectorAll('.zoom:not(.swiper-slide)');

		imgs.forEach((img) => observer.observe(img));

		function imageIn(entries, observer) {
			entries.forEach((entry) => {
				if (!entry.isIntersecting || entry.target.classList.contains('-in-view')) return;

				entry.target.classList.add('-in-view');

				/*
				gsap.to(entry.target.querySelector('.zoom__img'), {
					duration: 2.5,
					ease: 'power4.out',
					scale: 1
				});
				*/
			});
		}
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});

	$WINDOW.on('page:load-completed', (e) => {
		init();
	});
})();
